// Móc nhỏ của Bộ soi ảnh: đo khung, mốc "100%", nền soi nhớ theo máy.
import { useLayoutEffect, useState, type RefObject } from "react";
import { orientNatural } from "./orientation";
import type { PhotoLadder } from "./ladder";
import type { ViewerBg } from "./types";
import type { Size } from "./viewport";

const BG_KEY = "gn.photo-viewer.bg";

export const BG_CLASS: Record<ViewerBg, string> = {
  auto: "",
  gray: "bg-[#767676]",
  black: "bg-black",
  white: "bg-white",
};

export function readBg(): ViewerBg {
  try {
    const v = window.localStorage.getItem(BG_KEY);
    return v === "gray" || v === "black" || v === "white" ? v : "auto";
  } catch {
    return "auto";
  }
}

export function writeBg(v: ViewerBg) {
  try {
    window.localStorage.setItem(BG_KEY, v);
  } catch {
    // Không lưu được (chế độ riêng tư) thì thôi — chỉ là tiện nghi.
  }
}

export function useBoxSize(ref: RefObject<HTMLElement | null>): Size {
  const [size, setSize] = useState<Size>({ w: 0, h: 0 });
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () =>
      setSize((p) => (p.w === el.clientWidth && p.h === el.clientHeight ? p : { w: el.clientWidth, h: el.clientHeight }));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return size;
}

/** Kích thước mốc "100%" của một thang: tệp gốc (đã chỉnh hướng) hoặc bậc đầu đã tải. */
export function useReference(ladder: PhotoLadder) {
  const key = ladder.rungs[0]?.url ?? "";
  const [state, setState] = useState<{ key: string; first?: Size }>({ key });
  const first = state.key === key ? state.first : undefined;
  if (state.key !== key) setState({ key });
  const measure = (img: HTMLImageElement) => {
    if (first || img.naturalWidth <= 0) return;
    setState({ key, first: { w: img.naturalWidth, h: img.naturalHeight } });
  };
  return { ref: orientNatural(ladder.natural, first) ?? first, measure };
}

